window._cartRefresh = async function () {
	const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart.getSectionsToRender().map((section) => section.id);
	const sectionString = sections.join(',');
	const response = await fetch(`/?sections=${sectionString}`).then((res) => res.json());
	const cartDrawer = document.querySelector('cart-drawer');
	const cartIconBubbleHtml = new DOMParser()
		.parseFromString(response['cart-icon-bubble'], 'text/html')
		.getElementById('shopify-section-cart-icon-bubble').innerHTML;
	const cartIconBubble = document.getElementById('cart-icon-bubble');
	const cartData = await fetch('/cart.js').then((res) => res.json());
	if (cartDrawer) {
		const src = new DOMParser().parseFromString(response['cart-drawer'], 'text/html');
		const isEmpty = cartData.item_count === 0;
		cartDrawer.classList.toggle('is-empty', isEmpty);
		const inner = cartDrawer.querySelector('.drawer__inner');
		if (inner) inner.classList.toggle('is-empty', isEmpty);

		if (isEmpty) {
			// Panier vidé : re-rendu complet du drawer pour l'état vide.
			const cartInner = cartDrawer.querySelector('#CartDrawer');
			const sourceInner = src.querySelector('#CartDrawer');
			if (cartInner && sourceInner) cartInner.innerHTML = sourceInner.innerHTML;
		} else {
			// Préserver .drawer__giftbar et .product-recommendations__wrapper (rendus depuis les blocks,
			// absents du rendu isolé) : ne remplacer que l'en-tête, les articles et les totaux.
			['.drawer__header', '#CartDrawer-CartItems', '.cart-drawer__footer'].forEach((selector) => {
				const target = cartDrawer.querySelector(selector);
				const source = src.querySelector(selector);
				if (target && source) target.replaceWith(source);
			});
			const emptyBlock = cartDrawer.querySelector('.drawer__inner-empty');
			if (emptyBlock) emptyBlock.remove();
		}

		const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
		if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
		if (typeof window.refreshCartDrawerGiftbar === 'function') window.refreshCartDrawerGiftbar();
	}
	cartIconBubble.innerHTML = cartIconBubbleHtml;
	cartDrawer.open();
};
